import { PickupCycle } from '@/pages/Business/pages/PickupCycles/models';
import type { BranchesByCommerce } from '@/pages/Business/pages/PickupCycles/hooks/useBranchesMap';
import {
  findCentralBranch,
  formatActiveDays,
  formatBranchAddress,
  formatCycleTime,
} from '@/pages/Business/pages/PickupCycles/utils/format';

export interface PickupCycleRow {
  id: string;
  cycle: PickupCycle;
  commerceName: string;
  branchLabel: string;
  addressText: string | null;
  addressMissing: boolean;
  configurableBranchId: string | null;
  daysLabel: string;
  timeLabel: string;
  tagLabel: string;
}

export const buildPickupCycleRows = (
  cycles: PickupCycle[],
  branchesByCommerce: BranchesByCommerce,
): PickupCycleRow[] =>
  cycles.map((cycle) => {
    const branches = branchesByCommerce[cycle.commerceId] ?? [];

    let branchLabel: string;
    let addressText: string | null;
    let configurableBranchId: string | null;

    if (cycle.branchId) {
      const branch = branches.find((item) => item.id === cycle.branchId);
      branchLabel = branch?.name ?? 'Sucursal no encontrada';
      addressText = formatBranchAddress(branch?.address);
      configurableBranchId = cycle.branchId;
    } else {
      branchLabel = 'Casa central (por defecto)';
      const central = findCentralBranch(branches);
      addressText = formatBranchAddress(central?.address);
      configurableBranchId = central?.id ?? null;
    }

    return {
      id: cycle.id,
      cycle,
      commerceName: cycle.commerce?.name ?? '—',
      branchLabel,
      addressText,
      addressMissing: !addressText,
      configurableBranchId,
      daysLabel: formatActiveDays(cycle),
      timeLabel: formatCycleTime(cycle.cycleTime),
      tagLabel: cycle.tag ?? '—',
    };
  });
